import { useContext } from 'react';
import { filterDataContext } from '../FilterDataProvider';

export default function Item({ name, ckey, pkey, category, isHeading, ...rest }) {
  let uniqueID = `item-filter-${pkey}-${ckey}`;
  let {
    setFilterItemStatusFromNameAndCategory,
    isFilterItemOfNameAndCategoryIsActive,
  } = useContext(filterDataContext);

  // Ask context: is this filter active?
  const selected = isFilterItemOfNameAndCategoryIsActive(name, category);

  return (
    <li
      id={uniqueID}
      className="ais-RefinementList-item ais-RefinementList-item--selected"
      {...rest}
    >
      <label
        className="ais-RefinementList-label"
        onClick={() => {
          setFilterItemStatusFromNameAndCategory(name, category);
        }}
      >
        <input
          className="ais-RefinementList-checkbox"
          type="checkbox"
          checked={!!selected}   // controlled by context
          readOnly               
        />
        <span
          className="ais-RefinementList-labelText"
          style={isHeading ? { fontWeight: 700 } : undefined}
        >
          {name}
        </span>
      </label>
    </li>
  );
}
